import cloneDeep from "lodash/cloneDeep";
import { analyzePagesParallel } from "#src/api/ai.js";
import pageImage from "#src/extensions/page-image.js";
import {
  scaleOptions,
  translations,
  definedMultipliers,
} from "@local/extensions/utilities/scales.js";
import { alerts } from "#src/stores/alerts.js";

async function analyzePages(
  pages,
  doc,
  orgId,
  model,
  reasoningLevel,
  developer,
) {
  const pgs = pages.map((p) => ({
    page_id: p.id,
    document_id: doc.id,
    name: p.name,
    page: p.page,
  }));
  const images = await Promise.all(pgs.map((p) => pageImage(p)));
  const results = await analyzePagesParallel({
    pages: pgs.map((p, i) => ({ ...p, image: images[i] })),
    organization_id: orgId,
    model,
    reasoning_level: reasoningLevel,
  });

  let goodResults = 0;
  let badResults = 0;
  if (results.data) {
    const data = cloneDeep(doc.data);
    results.data.pages.forEach((r) => {
      const page = data.pages[r.page_id];
      if (r.error) {
        badResults++;
        if (developer) {
          console.log("Failed to analyze page:", r.page_id);
          console.log("Model reasoning:", r.reasoning);
        }
      } else if (page && r.page) {
        goodResults++;
        let paper = r.page.scale.paper.trim().replaceAll(/\s/g, "");
        let real = r.page.scale.real.trim().replaceAll(/\s/g, "");
        if (translations[paper] != undefined) {
          paper = translations[paper];
        }
        if (translations[real] != undefined) {
          real = translations[real];
        }
        const scale = `${paper}:${real}`;
        if (definedMultipliers[scale] != undefined) {
          page.scale = scale;
        } else {
          if (developer) {
            console.log("Failed to get page scale:", r.page_id);
            console.log("Extracted scale:", scale);
            console.log("Model reasoning:", r.page?.reasoning);
          }
        }

        if (r.page.page_name || r.page.page_number) {
          if (r.page.page_name && r.page.page_number) {
            page.label = `${r.page.page_number} - ${r.page.page_name}`;
          } else if (r.page.page_name) {
            page.label = r.page.page_name;
          } else if (r.page.page_number) {
            page.label = r.page.page_number;
          }
        }
      }
    });

    if (goodResults > 0) {
      alerts.add({
        type: "ok",
        message: `Successfully analyzed ${goodResults} pages.`,
      });
    }
    if (badResults > 0) {
      alerts.add({
        type: "error",
        message: `Failed to analyze ${badResults} pages.`,
      });
    }

    return data;
  }

  return null;
}

export default analyzePages;
